/**
 * Toast 通知组件
 */

import React from "react";

interface Props {
  message: string;
  type: "success" | "error" | "info";
}

export default function Toast({ message, type }: Props) {
  return (
    <div className={`toast toast-${type}`}>
      {type === "success" && "✓ "}
      {type === "error" && "✕ "}
      {type === "info" && "ℹ "}
      {message}
    </div>
  );
}